<template>
  <v-container fluid>
    <v-row dense v-if="!createFlg">
      <v-col cols="3" sm="3" md="3" lg="3" xl="3">
        <div align="left">
          <v-btn color="grey" small class="black--text" @click="toBack" :disabled="lockBack">前の申請へ</v-btn>
        </div>
      </v-col>
      <v-col cols="6" sm="6" md="6" lg="6" xl="6">

      </v-col>
      <v-col cols="3" sm="3" md="3" lg="3" xl="3">
        <div align="right">
          <v-btn color="grey" small class="black--text" @click="toForward" :disabled="lockForward">次の申請へ</v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card
      class="d-flex justify-center flex-column mx-auto my-6 flat"
      width="1200"
      color="#fff"
    >
      <v-card-title class="d-flex justify-center pa-0 mt-6" color="#CCFFCC">{{ title }}</v-card-title>
      <v-card-text class="d-flex justify-center flex-column">
        <p style="white-space:pre-wrap;" v-html="autoLink(body)"></p>
      </v-card-text>
    </v-card>

    <v-card
      class="d-flex justify-center flex-column mx-auto my-6 flat"
      width="1200"
      color="#fff"
    >

      <v-card-text class="d-flex justify-center flex-column" v-if="!createFlg">
        <v-row dense>
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">対象者</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ requestUserNm }}</v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">所属</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ kateiNm }}/{{ buNm }}/{{ kaNm }}  {{ gakunenNm }}年{{ gakkyuNm }}組{{ syussekiNo }}番</v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">学籍番号</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ gakusekiCd }}</v-col>
        </v-row>
        <v-row dense v-if="!createFlg">
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">申請日時</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ insDate }}</v-col>
        </v-row>
        <v-row dense v-if="!createFlg">
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">最終更新日時</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ updDate }}</v-col>
        </v-row>
        <v-row dense v-if="!createFlg">
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">最終更新者</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ updUserNm }}</v-col>
        </v-row>
        <v-row dense v-if="!createFlg">
          <v-col cols="12" sm="1" md="1" lg="1" xl="1" class="font-weight-bold">処理状況</v-col>
          <v-col cols="12" sm="11" md="11" lg="11" xl="11">{{ statusNm }}</v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="d-flex justify-center flex-column" style="white-space: pre-line;" v-if="createFlg">
        <p>調査書の発行を申請します。</p>
        <p>志望する大学を明細に登録してから申請してください。複数の大学を登録可能です。</p>
        <p>志望する大学、学部、学科等が選択肢に登録されていない場合は任意の内容で選択し、備考欄に志望する大学、学部、学科を入力してください。</p>
      </v-card-text>
    </v-card>
    
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <v-card
        class="d-flex justify-center flex-column mx-auto my-6 pb-3 flat"
        width="1200"
        color="#fff"
      >
        <v-card-title class="d-flex justify-left" style="background-color: #CCFFCC;">【生徒・保護者】入力欄</v-card-title>
        <v-card-text class="pt-4" v-if="createFlg">
            <v-row dense>
                <v-col dense cols="12" class="d-flex mt-3">
                    <ValidationProvider
                        name="都道府県"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                        <v-autocomplete
                            prepend-icon="$cet_required"
                            v-model="prefecture"
                            label="検索：都道府県"
                            placeholder="検索：都道府県"
                            item-text="name"
                            item-value="code"
                            :items="prefectureList"
                            :error-messages="errors[0]"
                            outlined
                            dense
                            @change="getUniversityKbn"
                            :disabled="!createFlg"
                            hide-details="auto"
                            background-color="white"
                        >
                        </v-autocomplete>
                    </ValidationProvider>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col dense cols="12" class="d-flex mt-3">
                    <ValidationProvider
                        name="大学区分"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-autocomplete
                          prepend-icon="$cet_required"
                          v-model="universityKbn"
                          label="検索：大学区分"
                          placeholder="検索：大学区分"
                          item-text="name"
                          item-value="code"
                          :items="universityKbnList"
                          :error-messages="errors[0]"
                          outlined
                          dense
                          @change="getUniversityName"
                          hide-details="auto"
                          background-color="white"
                          :disabled="prefecture === ''"
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col dense cols="8" class="flex mt-3">
                    <ValidationProvider
                        name="大学名称"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-autocomplete
                          prepend-icon="$cet_required"
                          v-model="universityName"
                          label="検索：大学名称"
                          placeholder="検索：大学名称"
                          item-text="name"
                          item-value="code"
                          :items="universityNameList"
                          :error-messages="errors[0]"
                          outlined
                          dense
                          @change="getGakubuGakka"
                          hide-details="auto"
                          background-color="white"
                          return-object
                          :disabled="prefecture === '' || universityKbn === ''"
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                </v-col>
                <v-col dense cols="4" class="d-flex mt-3">
                    <ValidationProvider
                        name="大学コード"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-text-field
                          prepend-icon="$cet_required"
                          v-model="universityCode"
                          label="大学コード"
                          placeholder="大学コード"
                          outlined
                          dense
                          @change="setUniversityName"
                          :error-messages="errors[0]"
                          hide-details="auto"
                          background-color="white"
                          :disabled="prefecture === '' || universityKbn === ''"
                      >
                      </v-text-field>
                    </ValidationProvider>
                </v-col>
            </v-row>

            <v-row dense>
                <v-col dense cols="12" class="flex mt-3">
                    <ValidationProvider
                        name="学部/学科"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-autocomplete
                          prepend-icon="$cet_required"
                          v-model="gakubuGakka"
                          label="検索：学部/学科"
                          placeholder="検索：学部/学科"
                          item-text="name"
                          item-value="code"
                          :items="gakubuGakkaList"
                          :error-messages="errors[0]"
                          outlined
                          dense
                          @change="getNitteiHoshiki"
                          hide-details="auto"
                          background-color="white"
                          return-object
                          :disabled="universityCode === '' || universityName === null"
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                </v-col>
            </v-row> 
            
            <v-row dense>
                <v-col dense cols="12" class="flex mt-3">
                    <ValidationProvider
                        name="日程/方式"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-autocomplete
                          prepend-icon="$cet_required"
                          v-model="nitteiHoshiki"
                          label="検索：日程/方式"
                          placeholder="検索：日程/方式"
                          item-text="name"
                          item-value="code"
                          :items="nitteiHoshikiList"
                          :error-messages="errors[0]"
                          outlined
                          dense
                          hide-details="auto"
                          background-color="white"
                          return-object
                          :disabled="gakubuGakka === null"
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                </v-col>
            </v-row> 

            <v-row dense>
                <v-col dense cols="12" class="flex mt-3">
                    <ValidationProvider
                        name="試験形態"
                        rules="required"
                        v-slot="{ errors }"
                        :skipIfEmpty="false"
                    >
                      <v-autocomplete
                          prepend-icon="$cet_required"
                          v-model="testForm"
                          label="検索：試験形態"
                          placeholder="検索：試験形態"
                          item-text="name"
                          item-value="code"
                          :items="testFormList"
                          :error-messages="errors[0]"
                          outlined
                          dense
                          hide-details="auto"
                          background-color="white"
                          return-object
                          :disabled="(nitteiHoshiki === null || nitteiHoshiki === '')"
                      >
                      </v-autocomplete>
                    </ValidationProvider>
                </v-col>
            </v-row>
            
            <v-row dense>
                <v-col dense cols="12" class="flex mt-3">
                  <ValidationProvider name="備考" rules="max:50" v-slot="{ errors }" vid="biko">
                      <v-text-field
                          v-model="biko"
                          label="入力:備考"
                          placeholder="備考"
                          outlined
                          dense
                          :error-messages="errors[0]"
                          hide-details="auto"
                          background-color="white"
                      >
                      </v-text-field>
                  </ValidationProvider>
                </v-col>
            </v-row>
         
            <v-row dense class="d-flex justify-center">
                <v-col dense cols="12" md="4">
                  <v-btn color="accent" class="ml-auto mt-0 black--text" @click="addRecord" :disabled="invalid">追加</v-btn>
                </v-col>
                <v-spacer cols="12" md="4"></v-spacer>
                <v-spacer cols="12" md="4"></v-spacer>
            </v-row>
        </v-card-text>

            <!-- レコード -->
            <v-data-table
              v-if="schoolReportRecords.length > 0"
              :headers="tableHeaders"
              :items="schoolReportRecords"
              :item-class="getRowClass"
              :items-per-page="15"
              hide-default-footer
              class="mt-6"
            >
              <template #[`item.no`]="{ index }">
                {{ index + 1 }}
              </template>
              <template #[`item.actions`]="{ item }" v-if="createFlg">
                <v-btn color="grey" dark small @click="deleteRecord(item)">
                  削除
                </v-btn>
              </template>
            </v-data-table>
        </v-card>

      <v-card
        class="d-flex justify-center flex-column mx-auto my-6 pb-3 flat"
        width="1200"
        color="#fff"
      >
        <v-card-title class="d-flex justify-left" style="background-color: #FFFFCC;">【教職員】入力欄</v-card-title>
        <div v-for="(question, index) in filteredTeacherList" :key="question.id">
          <v-row dense class="mx-3 mt-1 grey lighten-2">
            <v-col cols="12" class="py-0">
              <div class="mx-2">{{ (index + 1) }}問目 
                <v-icon v-if="question.required">$cet_required</v-icon>
                <span class="red--text ml-2">
                  ※学校入力項目
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row dense class="mx-5 mt-1">
            <v-col cols="12" class="py-0">
              <v-card-text class="d-flex pa-2 justify-center flex-column">
                <p style="white-space:pre-wrap;" v-html="autoLink(question.content)"></p>
              </v-card-text>
            </v-col>
          </v-row>
          <v-divider class="mx-4"></v-divider>
          <!-- テキスト回答 -->
          <v-row dense class="ml-5 my-1" v-if="question.type == '0'">
            <v-col cols="12">
              <ValidationProvider name="回答" :rules="question.rules" v-slot="{ errors }" :vid="`T_${question.id}`">
                <v-row dense class="mx-1 my-0">
                  <v-col cols="12" class="pb-0">
                    <v-textarea
                      v-model="question.value"
                      label="回答"
                      :error-messages="errors[0]"
                      :counter="question.charLimit"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="question.questionDisabled"
                    ></v-textarea>
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- チェックボックス回答 -->
          <v-row dense class="ml-5 my-1" v-if="question.type=='1'">
            <v-col cols="12">
              <ValidationProvider name="チェック" :rules="question.rules" v-slot="{ errors }" :vid="`T_${question.id}`">
                <v-row dense v-for="checkOption in question.option" :key="checkOption.id" class="mx-1 my-0">
                  <v-col cols="12" class="py-0">
                    <v-checkbox
                      class="mb-2 mr-5"
                      v-model="question.value"
                      :label="checkOption.title"
                      :value="checkOption.id"
                      :error-messages="errors[0]"
                      dense
                      hide-details="auto"
                      :disabled="question.questionDisabled"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row dense v-if="question.etcInputFlg == true" class="mx-1 my-0">
                  <v-col cols="12" class="d-flex py-0">
                    <v-checkbox
                      class="mb-2 mr-5"
                      v-model="question.value"
                      label="その他"
                      value="999"
                      dense
                      @change="clearEtcInputTextCheck(question)"
                      hide-details="auto"
                      :disabled="question.questionDisabled"
                    ></v-checkbox>
                    <v-text-field
                      v-model="question.etcInputText"
                      :disabled="(question.value.includes('999') == false) || question.questionDisabled"
                      label="自由入力"
                      outlined
                      dense
                      :counter="50"
                      hide-details="auto"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row >

          <!-- ラジオボタン回答 -->
          <v-row dense class="ml-5 my-1" v-if="question.type=='2'">
            <v-col cols="12">
              <ValidationProvider name="ラジオ" :rules="question.rules" v-slot="{ errors }" :vid="`T_${question.id}`" :skipIfEmpty="false">
                <v-radio-group 
                  v-model="question.value"
                  :error-messages="errors[0]"
                  hide-details="auto"
                  @change="clearEtcInputTextRadio(question)"
                  class="my-0"
                >
                  <v-row dense v-for="radioOption in question.option" :key="radioOption.id" class="mx-1 my-0">
                    <v-col cols="12" class="py-0">
                      <v-radio 
                        class="mb-5 mr-5"
                        :label="radioOption.title"
                        :value="radioOption.id"
                        :disabled="question.questionDisabled"
                      ></v-radio>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="question.etcInputFlg == true" class="mx-1 my-0">
                    <v-col cols="12" class="d-flex py-0">
                      <v-radio
                        class="mb-5 mr-5"
                        label="その他"
                        value="999"
                        :disabled="question.questionDisabled"
                      ></v-radio>
                      <v-text-field
                        v-model="question.etcInputText"
                        :disabled="(question.value != 999) || question.questionDisabled"
                        label="自由入力"
                        outlined
                        dense
                        :counter="50"
                        hide-details="auto"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-radio-group>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- 一行回答 -->
          <v-row dense class="ml-5 my-1" v-if="question.type == '3'">
            <v-col cols="12">
              <ValidationProvider name="回答" :rules="question.rules" v-slot="{ errors }" :vid="`T_${question.id}`">
                <v-row dense class="mx-1 my-0">
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="question.value"
                      label="回答"
                      :error-messages="errors[0]"
                      :counter="question.charLimit"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="question.questionDisabled"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>

          <!-- 日付回答 -->
          <v-row dense class="ml-5 my-1" v-if="question.type == '4'">
            <v-col cols="6" sm="4">
              <ValidationProvider name="回答" :rules="question.rules" v-slot="{ errors }" :vid="`T_${question.id}`">
                <v-row dense class="mx-1 my-0">
                  <v-col cols="12" class="pb-0">
                    <v-text-field
                      v-model="question.value"
                      label="回答"
                      type="date"
                      :error-messages="errors[0]"
                      outlined
                      dense
                      hide-details="auto"
                      :disabled="question.questionDisabled"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </ValidationProvider>
            </v-col>
          </v-row>
        </div>
        <ValidationProvider name="コメント" rules="max:300" v-slot="{ errors }" vid="comment">
            <v-card-title class="d-flex justify-left" v-if="!createFlg">学校コメント</v-card-title>
            <v-card-text class="pb-0" v-if="!createFlg">
              <v-textarea
                v-model="comment"
                label="コメント"
                rows="3"
                auto-grow
                outlined
                dense
                :disabled="!teacherFlg"
                :error-messages="errors[0]"
                :counter="300"
              />
            </v-card-text>
        </ValidationProvider>

        <v-card-actions class="mt-3" v-if="teacherFlg">
          <v-row dense>
            <v-col cols="3">
              <v-btn block color="grey" class="mr-auto mt-0 black--text" @click="cancelCertificateDetail">
                戻る
              </v-btn>
            </v-col>
            <v-col v-if="visibleUpdate" cols="3">
              <v-btn block color="accent" class="ml-auto mt-0 black--text" @click="updateContent" :disabled="invalid">
                内容更新
              </v-btn>
            </v-col>            
            <v-col v-if="visibleReturn" cols="3">
              <v-btn block color="red" class="mr-auto mt-0 black--text" @click="returnedByTeacher" :disabled="invalid">
                差し戻し
              </v-btn>
            </v-col>
            <v-col v-if="visibleWithdraw" cols="3">
              <v-btn block color="red" class="mr-auto mt-0 black--text" @click="withdrawnByApplicant" :disabled="createFlg">
                取り下げ
              </v-btn>
            </v-col>
            <v-col v-if="visibleApply" cols="3">
              <v-btn block color="red" class="ml-auto mt-0 black--text" @click="saveSchoolReportRequest" :disabled="schoolReportRecords.length === 0">
                申請
              </v-btn>
            </v-col>
            <v-col v-if="visibleIssue" cols="3">
              <v-btn block color="secondary" class="ml-auto mt-0 black--text" @click="issuedSchoolReportRequest" :disabled="invalid">
                発行済み
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <v-row dense class="mt-3 d-flex justify-center" v-if="!teacherFlg">
        <v-col cols="12" md="4">
          <v-btn block color="grey" class="mr-auto mt-0 black--text" @click="cancelCertificateDetail">
            戻る
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="visibleUpdate">
          <v-btn block color="accent" class="ml-auto mt-0 black--text" @click="updateContent" :disabled="invalid">
            内容更新
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="visibleReturn">
          <v-btn block color="red" class="mr-auto mt-0 black--text" @click="returnedByTeacher" :disabled="invalid">
            差し戻し
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="visibleWithdraw">
          <v-btn block color="red" class="mr-auto mt-0 black--text" @click="withdrawnByApplicant" :disabled="createFlg">
            取り下げ
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="visibleApply">
          <v-btn block color="red" class="ml-auto mt-0 black--text" @click="saveSchoolReportRequest" :disabled="schoolReportRecords.length === 0">
            申請
          </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="visibleIssue">
          <v-btn block color="secondary" class="ml-auto mt-0 black--text" @click="issuedSchoolReportRequest" :disabled="invalid">
            発行済み
          </v-btn>
        </v-col>
      </v-row>

    </ValidationObserver>
  </v-container>
</template>

<script>
import { httpsCallable, getFunctions } from "firebase/functions";
import Autolinker from 'autolinker';
import * as Validator from 'validatorjs';
Validator.useLang('ja');

export default {
  props: [
    'schoolReportId',
    'requestId',
    'requestUserId',
    'schoolReportIdBuff',
    'requestIdBuff',
    'requestUserIdBuff',
    'requestListIndex',
  ],
  computed: {
    filteredTeacherList() {
      return this.questionListTeacher.filter(q => {
        return this.teacherFlg || (q.viewOnlyTeacher && !this.teacherFlg);
      })
    }
  },
  data() {
    return {
      title : "",
      body : "",
      kateiNm : "",
      buNm : "",
      kaNm : "",
      gakunenNm : "",
      gakkyuNm : "",
      syussekiNo : "",
      gakusekiCd : "",
      requestUserNm : "",
      createUserNm : "",
      updUserNm : "",
      insDate : "",
      updDate : "",
      groupId : "",
      questionListTeacher : [],
      comment : "",
      statusNm : "",
      lockBack: false,
      lockForward: false,

      // 都道府県セレクトボックス
      prefecture : "",
      prefectureList: [],
      // 大学区分セレクトボックス
      universityKbn : "",
      universityKbnInit: [],
      universityKbnList: [],
      // 大学コード
      universityCode : "",
      // 大学名称セレクトボックス
      universityName: null,
      universityNameList: [],
      // 学部/学科セレクトボックス
      gakubuGakka : null,
      gakubuGakkaList: [],
      // 日程/方式セレクトボックス
      nitteiHoshiki : null,
      nitteiHoshikiList: [],
      // 試験形態セレクトボックス
      testForm : null,
      testFormList: [],
      // 備考
      biko : "",

      // 追加レコード
      tableHeaders: [
      { text: 'No', value: 'no', sortable: false },
      { text: '大学名', value: 'universityName.name', sortable: false },
      { text: '学部', value: 'gakubuGakka.gakubuName', sortable: false },
      { text: '学科', value: 'gakubuGakka.gakkaName', sortable: false },
      { text: '日程方式', value: 'nitteiHoshiki.name', sortable: false },
      { text: '試験形態', value: 'testForm.name', sortable: false },
      { text: '備考', value: 'biko', sortable: false },
      { text: '操作', value: 'actions', sortable: false, align: 'end' }, 
      ],
      schoolReportRecords: [],

      // 新規登録フラグ
      createFlg: true,

      // 教員ユーザフラグ
      teacherFlg : false,

      // 各ボタンの表示制御
      visibleReturn : false,
      visibleWithdraw : false,
      visibleApply : false,
      visibleIssue : false,
      visibleUpdate : false,
    };
  },
  watch: {
    requestId: async function () {
      await this.load();
    }
  },
  // 初期表示時データ読み込み
  async created() {
    await this.load();
  },
  methods: {
    async load() {
      // 前の申請へ/次の申請へ ボタン制御
      this.lockBack = (this.requestListIndex == 0)?true:false;
      this.lockForward = (this.requestIdBuff.length == (this.requestListIndex+1))?true:false;
      // ローディング表示
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = {
        funcName: "loadSchoolReportRequestDetails",
        schoolReportId: this.schoolReportId,
        requestId: this.requestId,
        requestUserId: this.requestUserId,
      }
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((doc) => {
        this.title = doc.data.title;
        this.body = doc.data.body;
        this.kateiNm = doc.data.kateiNm,
        this.buNm = doc.data.buNm,
        this.kaNm = doc.data.kaNm,
        this.gakunenNm = doc.data.gakunenNm,
        this.gakkyuNm = doc.data.gakkyuNm,
        this.syussekiNo = doc.data.syussekiNo,
        this.gakusekiCd = doc.data.gakusekiCd,
        this.requestUserNm = doc.data.requestUserNm,
        this.createUserNm = doc.data.createUserNm,
        this.updUserNm = doc.data.updUserNm,
        this.insDate = doc.data.insDate,
        this.updDate = doc.data.updDate,
        this.questionListTeacher = doc.data.questionListTeacher;
        this.comment = doc.data.comment;
        this.statusNm = doc.data.statusNm;
        this.createFlg = doc.data.createFlg;
        this.teacherFlg = doc.data.teacherFlg;
        this.visibleReturn = doc.data.visibleReturn;
        this.visibleWithdraw = doc.data.visibleWithdraw;
        this.visibleApply = doc.data.visibleApply;
        this.visibleIssue = doc.data.visibleIssue;
        this.visibleUpdate = doc.data.visibleUpdate;
        this.prefectureList = [{code: "", name: ""}].concat(doc.data.prefectureMst);
        this.universityKbnInit = [{code: "", name: ""}].concat(doc.data.universityKbnMst);
        this.universityKbnList = [{code: "", name: ""}].concat(doc.data.universityKbnMst);
        this.testFormList = doc.data.testFormMst;
        this.schoolReportRecords = doc.data.appliedData;
      }).catch((e) => {
        console.log(e.message);
      });
      this.$root.loading = false;
    },
    // 前の連絡へボタン
    toBack() {
      this.$router.push({
        name: "SchoolReportRequestDetail",
        params: {
          schoolReportId : this.schoolReportIdBuff[this.requestListIndex - 1],
          requestId: this.requestIdBuff[this.requestListIndex - 1],
          requestUserId: this.requestUserIdBuff[this.requestListIndex - 1],
          schoolReportIdBuff: this.schoolReportIdBuff,
          requestIdBuff: this.requestIdBuff,
          requestUserIdBuff: this.requestUserIdBuff,
          requestListIndex: this.requestListIndex - 1,
        }
      });
    },
    // 次の連絡へボタン
    toForward() {
      this.$router.push({
        name: "SchoolReportRequestDetail",
        params: {
          schoolReportId : this.schoolReportIdBuff[this.requestListIndex + 1],
          requestId: this.requestIdBuff[this.requestListIndex + 1],
          requestUserId: this.requestUserIdBuff[this.requestListIndex + 1],
          schoolReportIdBuff: this.schoolReportIdBuff,
          requestIdBuff: this.requestIdBuff,
          requestUserIdBuff: this.requestUserIdBuff,
          requestListIndex: this.requestListIndex + 1,
        }
      });
    },

    // 大学区分セレクトボックスの取得
    async getUniversityKbn(prefectureCd) {
      // セレクトボックスの初期化
      this.universityKbn = "";
      this.universityCode = "";
      this.universityName = null;
      this.gakubuGakka = null;
      this.nitteiHoshiki = null;
      // 都道府県が空白の場合、スキップ
      if (prefectureCd === '' || prefectureCd === null) {
        return;
      }

      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = {
        funcName : "getUniversityKbnSelectBox",
        prefectureCd : prefectureCd
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        const sortCodes = ret.data.map(item => item.code);
        this.universityKbnList = this.universityKbnInit.filter(kbn => 
            sortCodes.includes(kbn.code)
        );
      }).catch((e) => {
        console.log(e.message);
      });
      this.$root.loading = false;
    },

    // 大学名称セレクトボックスの取得
    async getUniversityName(code) {
      // セレクトボックスの初期化
      this.universityCode = "";
      this.gakubuGakka = null;
      this.nitteiHoshiki = null;

      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = { 
        funcName : "getUniversityNameSelectBox",
        prefectureCd : this.prefecture,
        universityKbnCd : code
      };

      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        this.universityNameList = [{code: "", name: ""}].concat(ret.data);
      }).catch((e) => {
        console.log(e.message);
      });
      this.$root.loading = false;   
    },

    // 大学名称のセット
    async setUniversityName(code) {
      // セレクトボックスの初期化
      this.gakubuGakka = null;
      this.nitteiHoshiki = null;      

      this.universityNameList.forEach((item => {
        if (item.code === code) {
          this.universityName = item;
        }
      }));
    },

    // 学部/学科の取得
    async getGakubuGakka(university) {
      // セレクトボックスの初期化
      this.nitteiHoshiki = null;
      //大学コードの設定
      this.universityCode = university.code;
      // 大学名称が空白の場合、スキップ
      if (university.code === '' || university.code === null) {
        return;
      }

      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = { 
        funcName : "getGakubuGakkaSelectBox",
        universityCode : university.code
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        this.gakubuGakkaList = ret.data;
      }).catch((e) => {
        console.log(e.message);
      });
      this.$root.loading = false;   
    },

    // 日程/方式の取得
    async getNitteiHoshiki(gakubuGakka) {
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = { 
        funcName : "getNitteiHoshikiSelectBox",
        universityCode : this.universityCode,
        gakubuGakkaCode : gakubuGakka.code  
      };
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((ret) => {
        this.nitteiHoshikiList = ret.data;
      }).catch((e) => {
        console.log(e.message);
      });
      this.$root.loading = false;   
    },

    // 追加ボタン押下
    addRecord(){
      //  上限チェック
      if (this.schoolReportRecords.length >= 15) {
        alert("申請内容の追加上限は15件になります。");
        return;
      }

      // 重複チェック
      const check = this.schoolReportRecords.some(item => 
      (item.universityName.code === this.universityName.code)
      && (item.gakubuGakka.code === this.gakubuGakka.code)
      && (item.gakubuGakka.gakubuCode === this.gakubuGakka.gakubuCode)
      && (item.gakubuGakka.gakkaCd === this.gakubuGakka.gakkaCd)
      && (item.nitteiHoshiki.code === this.nitteiHoshiki.code)
      && (item.nitteiHoshiki.nitteiCode === this.nitteiHoshiki.nitteiCode)
      && (item.nitteiHoshiki.hoshikiCode === this.nitteiHoshiki.hoshikiCode)
      && (item.testForm.code === this.testForm.code));

      if (check) {
        alert("同一の申請内容が既に追加されています。");
        return;
      }

      // Noの採番
      const no = this.schoolReportRecords.length + 1;

      this.schoolReportRecords.push({
        no : no,
        universityName : this.universityName,
        gakubuGakka : this.gakubuGakka,
        nitteiHoshiki : this.nitteiHoshiki,
        testForm : this.testForm,
        biko : this.biko,
        applyFlg : false
      });
    },

    // 戻るボタン押下
    cancelCertificateDetail(){
      this.$router.push({
        name: "CertificateRequestList",
      });
    },

    // 削除ボタン
    deleteRecord(item) {
      var result = confirm("削除してよろしいですか？");
      if (!result) {
        return;
      }

      const index = this.schoolReportRecords.indexOf(item);
      if (index > -1) {
        this.schoolReportRecords.splice(index, 1);
      }
    },

    // 内容更新
    async updateContent(){
      await this.updateRequestStatus(null, null);
    },

    // 申請
    async saveSchoolReportRequest(){
      if(!this.validAnswers()) {
        return;
      }
      // ローディング表示
      this.$root.loading = true;
      let data = {};

      if (this.createFlg) {
        // 追加データ
        const recordData = this.schoolReportRecords.map((item, index) => ({
          no : index + 1,
          universityCode : item.universityName.code,
          universityName : item.universityName.name,
          gakubuGakkaCode : item.gakubuGakka.code,
          gakubuGakkaName : item.gakubuGakka.name,
          gakubuCode : item.gakubuGakka.gakubuCode,
          gakubuName : item.gakubuGakka.gakubuName,
          gakkaCode : item.gakubuGakka.gakkaCode,
          gakkaName : item.gakubuGakka.gakkaName,
          nitteiHoshikiCode : item.nitteiHoshiki.code,
          nitteiHoshikiName : item.nitteiHoshiki.name,
          nitteiCode : item.nitteiHoshiki.nitteiCode,
          nitteiName : item.nitteiHoshiki.nitteiName,
          hoshikiCode : item.nitteiHoshiki.hoshikiCode,
          hoshikiName : item.nitteiHoshiki.hoshikiName,
          testFormCode : item.testForm.code,
          testFormName : item.testForm.name,
          biko : item.biko
        }));

        // 登録
        data = {
          funcName: "createSchoolReportRequest",
          schoolReportId : this.schoolReportId,
          requestUserId : this.requestUserId,
          questionListTeacher : this.questionListTeacher,
          recordData : recordData
        }

        const functions = getFunctions(this.$firebase);
        functions.region = "asia-northeast1";
        const schoolAidHomeLogined = httpsCallable(functions,"schoolAidHomeLogined");
        await schoolAidHomeLogined(data).then((res) => {
          // ローディング非表示
          if (res.data === "success"){
            alert("更新しました。");
            this.$root.loading = false;
            this.$router.push({
              name: "CertificateRequestList",
            });
          } else if (res.data.find(item => item.applyFlg === true)) {
            alert("重複している申請内容があります。");

            this.schoolReportRecords = this.schoolReportRecords.map(record => {
              const matched = res.data.find(item => item.no == record.no);
              return {
                  ...record,
                  applyFlg: matched ? matched.applyFlg : false 
              };
            });
          } else {
            alert("データ更新に失敗しました。");
          }
        });

        this.$root.loading = false;
      } else {
        // 再申請
        await this.updateRequestStatus("0", "申請中");
      }

    },

    // 追加レコードの背景色の変更
    getRowClass(item) {
      if (item && item.applyFlg === true) {
        return 'registered-row';
      }
      return '';
    },

    // 差し戻し
    async returnedByTeacher() {
      await this.updateRequestStatus("1", "差し戻し");
    },
    // 取り下げ
    async withdrawnByApplicant() {
      await this.updateRequestStatus("2", "取り下げ");
    },
    // 発行済み
    async issuedSchoolReportRequest() {
      await this.updateRequestStatus("3", "発行済み");
    },

    // ステータスおよび申請内容の更新
    async updateRequestStatus(status, statusNm){
      if(!this.validAnswers()) return;
      this.$root.loading = true;
      const functions = getFunctions(this.$firebase);
      functions.region = "asia-northeast1";
      const data = {
        funcName: "updateSchoolReportRequestStatus",
        schoolReportId: this.schoolReportId,
        questionListTeacher : this.questionListTeacher,
        comment : this.comment,
        requestId: this.requestId,
        requestUserId: this.requestUserId,
        teacherFlg: this.teacherFlg,
        status: status,
        statusNm: statusNm,
      }
      const schoolAidHomeLogined = httpsCallable(functions, "schoolAidHomeLogined");
      await schoolAidHomeLogined(data).then((res) => {
        if (res.data == "success"){
          alert("更新しました。");
        } else {
          alert("データ更新に失敗しました。");
        }
      }).catch((e) => {
        console.log(e.message);
      });
      this.$router.push({
        name: "CertificateRequestList",
      });
      this.$root.loading = false;
    },

    validAnswers() {
      let rules = {
        自由入力: 'required|max:50',
      }
      // その他入力チェック
      for(let question of this.questionListTeacher){
        if(question.type == "1" && question.value.includes('999')) {
          let data = {
            自由入力: question.etcInputText,
          }
          let validation1 = new Validator(data, rules);
          if(validation1.fails()){
            let hash1 = validation1.errors.all();
            let errors1 = [];
            for (let key in hash1) {
              errors1.push(...hash1[key]);
            }
            alert((question.index + 1) + "問目\r\n" + errors1.join("\r\n"));
            return false;
          }
        }
        if(question.type == "2" && question.value == 999) {
          let data = {
            自由入力: question.etcInputText,
          }
          let validation2 = new Validator(data, rules);
          if(validation2.fails()){
            let hash2 = validation2.errors.all();
            let errors2 = [];
            for (let key in hash2) {
              errors2.push(...hash2[key]);
            }
            alert((question.index + 1) + "問目\r\n" + errors2.join("\r\n"));
            return false;
          }
        }
      }
      return true;
    },

    autoLink(text) {
      const autolinker = new Autolinker();
      return autolinker.link(text);
    },
    // その他入力選択解除時(複数選択)
    clearEtcInputTextCheck(question) {
      if(question.value.includes('999') == false){
        question.etcInputText = "";
      }
    },
    // その他入力選択解除時(単選択)
    clearEtcInputTextRadio(question) {
      if(question.value != '999'){
        question.etcInputText = "";
      }
    },
  }
};
</script>

<style scoped>
.v-data-table >>> .registered-row {
  background-color: #FFCDD2 !important; /* 薄い赤（ピンク系） */
}
</style>